var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelbeeLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.15 56.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb5b41;}.cls-2{fill:#ffcf05;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "welbee_logo_full_red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,13.59H30.52A1.6,1.6,0,0,0,29,14.72L24.57,29.8,19.4,14.66a1.58,1.58,0,0,0-1.49-1.07H15.72a1.58,1.58,0,0,0-1.5,1.07L9.14,29.79,4.66,14.72a1.58,1.58,0,0,0-1.51-1.13H1.58a1.58,1.58,0,0,0-1.28.65,1.55,1.55,0,0,0-.22,1.41L6.49,35.39A1.57,1.57,0,0,0,8,36.48h2.07a1.58,1.58,0,0,0,1.5-1.08l5-15.22,5.64,15.27a1.58,1.58,0,0,0,1.48,1h2a1.58,1.58,0,0,0,1.5-1.09L33.5,15.65a1.58,1.58,0,0,0-.23-1.41A1.56,1.56,0,0,0,32,13.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.32,16.2a9.63,9.63,0,0,0-3.47-2.37,11.84,11.84,0,0,0-4.4-.81,12.38,12.38,0,0,0-4.68.88,11.08,11.08,0,0,0-3.72,2.48,11.4,11.4,0,0,0-2.45,3.81A13.15,13.15,0,0,0,36.73,25a13.54,13.54,0,0,0,.8,4.66,11.31,11.31,0,0,0,2.3,3.82,11,11,0,0,0,3.65,2.57,11.73,11.73,0,0,0,4.83,1A14.36,14.36,0,0,0,54,36a10.91,10.91,0,0,0,3.67-2.7,1.57,1.57,0,0,0-.21-2.3l-.95-.74a1.57,1.57,0,0,0-2.11.16A8.67,8.67,0,0,1,52.19,32a8.54,8.54,0,0,1-3.88.8,6.45,6.45,0,0,1-4.71-2,7.63,7.63,0,0,1-1.46-2.15,8.28,8.28,0,0,1-.42-1.18.75.75,0,0,1,.13-.65.77.77,0,0,1,.62-.31H57.76A1.57,1.57,0,0,0,59.33,25a15.34,15.34,0,0,0-.77-5A10.56,10.56,0,0,0,56.32,16.2Zm-2.07,6.16a.76.76,0,0,1-.6.29H42.55a.79.79,0,0,1-.63-.32.75.75,0,0,1-.11-.66,6.34,6.34,0,0,1,1.82-2.85,6.74,6.74,0,0,1,4.68-1.59,6.29,6.29,0,0,1,4.54,1.58,5.62,5.62,0,0,1,1.56,2.92A.73.73,0,0,1,54.25,22.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.85,
    width: 4.49,
    height: 36.48,
    rx: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.78,16.45A11,11,0,0,0,95,13.93a13,13,0,0,0-4.9-.91,10.21,10.21,0,0,0-4.59,1,11.35,11.35,0,0,0-3,2.2V1.58A1.57,1.57,0,0,0,80.9,0H79.56A1.58,1.58,0,0,0,78,1.58V34.9a1.58,1.58,0,0,0,1.57,1.58H80.9a1.57,1.57,0,0,0,1.57-1.58V33.36a9.77,9.77,0,0,0,2.77,2.34,10.76,10.76,0,0,0,5.42,1.35,11.34,11.34,0,0,0,4.5-.91,11,11,0,0,0,3.65-2.52,12,12,0,0,0,2.42-3.81,13.39,13.39,0,0,0,0-9.55A11.71,11.71,0,0,0,98.78,16.45ZM97.34,25a9.07,9.07,0,0,1-.52,3.09,7.27,7.27,0,0,1-1.5,2.46A7.18,7.18,0,0,1,93,32.24a8.13,8.13,0,0,1-6.13,0A7,7,0,0,1,83,28.13a9.47,9.47,0,0,1,0-6.19,7.27,7.27,0,0,1,1.5-2.46,7.18,7.18,0,0,1,2.35-1.65,8.13,8.13,0,0,1,6.13,0,7.18,7.18,0,0,1,2.35,1.65,7.27,7.27,0,0,1,1.5,2.46A9.17,9.17,0,0,1,97.34,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.61,16.2a9.63,9.63,0,0,0-3.47-2.37,11.82,11.82,0,0,0-4.39-.81,12.43,12.43,0,0,0-4.69.88,11,11,0,0,0-6.16,6.29A13,13,0,0,0,107,25a13.54,13.54,0,0,0,.8,4.66,11.31,11.31,0,0,0,2.3,3.82,11,11,0,0,0,3.65,2.57,11.78,11.78,0,0,0,4.84,1,14.31,14.31,0,0,0,5.63-1,10.91,10.91,0,0,0,3.67-2.7,1.55,1.55,0,0,0,.4-1.18,1.63,1.63,0,0,0-.6-1.12l-1-.74a1.57,1.57,0,0,0-2.11.16A8.67,8.67,0,0,1,122.48,32a8.5,8.5,0,0,1-3.87.8,6.42,6.42,0,0,1-2.62-.53,6.58,6.58,0,0,1-2.1-1.45,7.4,7.4,0,0,1-1.45-2.15,7.25,7.25,0,0,1-.43-1.18.72.72,0,0,1,.14-.65.76.76,0,0,1,.62-.31h15.28A1.58,1.58,0,0,0,129.63,25a15.33,15.33,0,0,0-.78-5A10.42,10.42,0,0,0,126.61,16.2Zm-2.07,6.16a.73.73,0,0,1-.6.29H112.85a.79.79,0,0,1-.64-.32.75.75,0,0,1-.11-.66,6.43,6.43,0,0,1,1.82-2.85,6.76,6.76,0,0,1,4.69-1.59,6.26,6.26,0,0,1,4.53,1.58,5.62,5.62,0,0,1,1.56,2.92A.73.73,0,0,1,124.54,22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.29,26.57h15.28A1.58,1.58,0,0,0,157.15,25a15.07,15.07,0,0,0-.78-5,10.54,10.54,0,0,0-2.23-3.77,9.8,9.8,0,0,0-3.47-2.37,11.91,11.91,0,0,0-4.4-.81,12.34,12.34,0,0,0-4.68.88,10.94,10.94,0,0,0-6.17,6.29,13,13,0,0,0-.88,4.85,13.54,13.54,0,0,0,.8,4.66,11.4,11.4,0,0,0,2.3,3.82,11,11,0,0,0,3.65,2.57,11.78,11.78,0,0,0,4.84,1,14.31,14.31,0,0,0,5.63-1,10.91,10.91,0,0,0,3.67-2.7,1.55,1.55,0,0,0,.4-1.18,1.59,1.59,0,0,0-.6-1.12l-1-.74a1.57,1.57,0,0,0-2.11.16A8.67,8.67,0,0,1,150,32a8.5,8.5,0,0,1-3.87.8,6.42,6.42,0,0,1-2.62-.53,6.58,6.58,0,0,1-2.1-1.45A7.4,7.4,0,0,1,140,28.71a7.25,7.25,0,0,1-.43-1.18.78.78,0,0,1,.76-1Zm11.78-4.21a.76.76,0,0,1-.61.29H140.37a.77.77,0,0,1-.63-.32.72.72,0,0,1-.12-.66,6.43,6.43,0,0,1,1.82-2.85,6.76,6.76,0,0,1,4.69-1.59,6.26,6.26,0,0,1,4.53,1.58,5.62,5.62,0,0,1,1.56,2.92A.76.76,0,0,1,152.07,22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.42,47.05s-.2-.15-.23-.18S146.48,47.09,146.42,47.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.57 47.92 146.49 47.84 146.65 48.08 146.57 47.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.18,48.39c.39.25.09-.22.28-.2l.1.05L146.3,48C146.26,48.11,146.34,48.4,146.18,48.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.23,48c.15.11.07.15.09,0l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.28,47.93s-.14-.07,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.16,48.2,145.1,48c-.09-.06-.15,0-.19-.1C144.92,48,145,48.11,145.16,48.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.35,48.48l0-.07S145.28,48.38,145.35,48.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.29,48.24l0,.17c.06,0,.17.14,0-.07C145.42,48.44,145.33,48.34,145.29,48.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.38,48.26c.1,0,.19,0,.25.2C145.69,48.3,145.43,48.1,145.38,48.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.52,48.72l.15,0-.08-.15C146.63,48.69,146.41,48.63,146.52,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.65,48.37l.29.26,0-.12A.67.67,0,0,1,144.65,48.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.94,48.63l.05.18C145.07,48.77,145,48.7,144.94,48.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.71 48.85 145.56 48.5 145.69 48.88 145.71 48.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.4 48.58 144.28 48.37 144.45 48.69 144.4 48.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.26,48.75c-.09-.17-.24-.21-.28-.32a.92.92,0,0,0,.09.36C144.06,48.7,144.11,48.68,144.26,48.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.14,49a.57.57,0,0,0-.07-.21A1.25,1.25,0,0,0,144.14,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.84,48.88a.74.74,0,0,0-.24-.17l.21.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.82,48.9h0l-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.85,48.87h0S144.87,48.9,144.85,48.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.36,48.85c.07.15.1.35.34.44C145.6,49.13,145.46,49.08,145.36,48.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.11,49.1l.12,0a1,1,0,0,1-.17-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.14 49.2 145.11 49.1 145.07 49.1 145.14 49.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.44,49.1a.18.18,0,0,1,0,.2.23.23,0,0,0,.19,0C144.56,49.19,144.47,49.05,144.44,49.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.64,49v0S144.67,49.06,144.64,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144,49.61l0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.64,49.29c.07,0,.05,0,0-.13a.3.3,0,0,1,0,.1S144.64,49.31,144.64,49.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.11,49.18l.15.08C144.19,49.2,144.08,49.12,144.11,49.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.58,49h0C144.53,48.94,144.55,49,144.58,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.58,49a.77.77,0,0,0,.07.17.53.53,0,0,0,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.92,51.15c-.14-.22-.19-.48.06-.33a4.22,4.22,0,0,0-.93-1.17.6.6,0,0,1,.13.35c.11.1.37.13.44.37s-.14,0-.27-.08c.23.23.12.48.42.85v-.21C144.82,51,144.85,51.11,144.92,51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.21,49.55v0c-.06,0-.15-.06-.31-.19a.7.7,0,0,0,.11.3l.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.36,49.4c.15.23.15.39.38.59.09-.09-.08-.24-.09-.38-.11.17-.06-.15-.26-.19a.19.19,0,0,1,0-.12l-.16,0h0s0,0,0,0h0l.05.08c-.08,0-.05,0-.05-.08l0,0h0l-.06.23C144.28,49.51,144.31,49.47,144.36,49.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146,49.8a.11.11,0,0,1,0,0S146,49.81,146,49.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.86,49.74s-.09-.13,0-.14.09.09.16.16-.06-.22-.23-.25l0,0a1,1,0,0,1-.45-.24A4.58,4.58,0,0,0,145.86,49.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.14,49.64l0,.22.22.13-.09-.11C145.33,49.86,145.2,49.74,145.14,49.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.92 49.51 143.76 49.26 143.93 49.65 143.92 49.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.78 49.66 143.63 49.45 143.68 49.6 143.78 49.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.24,55.65l-.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.64,55.69v-.12C132.63,55.63,132.62,55.69,132.64,55.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.17,51.82c-.14-.21-.31-.54-.22-.27l.09.26C139.08,51.75,139.12,51.77,139.17,51.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.8,54.13l0,.09,0-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.85,55.29l-.12-.17A.66.66,0,0,0,135.85,55.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130,55.7l-.11.27C130,56,130,55.84,130,55.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142,50.82c-.11-.08-.17-.1-.21-.09C141.93,50.84,142.09,51,142,50.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.56,52.69a.34.34,0,0,0-.05.17A.31.31,0,0,0,132.56,52.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.65,50.81l0,0c0-.06,0-.11.1-.12C141.7,50.65,141.62,50.6,141.65,50.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.45,52.71v0S122.43,52.71,122.45,52.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.39,49.14a.1.1,0,0,1,.07,0S122.45,49.14,122.39,49.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143,50s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.79,50.83l.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.94,52.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.15,50.08l-.09,0A.26.26,0,0,0,143.15,50.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.07,50h.05S143.08,49.91,143.07,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143,50.05a.08.08,0,0,1,.08,0l0,0S143,50,143,50.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.64,53.87v0C126.56,53.94,126.58,53.93,126.64,53.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.65,55v0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.51,55.19c0-.35.06-.32.13-.26l-.23-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.27,55.65l.1.26c-.2.4-.3.24-.21.61.1-.87.53,0,.62-.91l.08.19s0,0-.06,0c.14.43.17-.62.38-.48a.28.28,0,0,1,.06.3l.18-.21s0,.17,0,.15l.26-.05v0c0-.14.14-.35.18-.44.06.13,0,.09,0,.2l.14-.21c.05.23-.07.45-.17.42.1.87.13-.22.4.3l-.14.1c.08.5.19.32.34.64,0-.17-.3-.79-.14-1,0,.06.1.09.19-.08,0,.31.08.24.18.22v.41c.11-.11.11-.32.17-.51.12,0,.15.36.18.63.2.06-.14-.51.09-.6.17.16.28,0,.47-.27.12.14,0,.26,0,.37l.09-.33s0,.11,0,.16c.08-.13,0-.41.12-.53,0-.45.3.66.44.13,0,.11,0,.25,0,.41a2.25,2.25,0,0,0,.33-.73l.17.26a1.48,1.48,0,0,1,.07-1c-.05-.14-.09-.27-.12-.33l.17-.24a.93.93,0,0,1,0,.39l0-.11a1.13,1.13,0,0,1,0,.62l-.1-.24a4,4,0,0,0,0,.77.33.33,0,0,1,.05-.12,1,1,0,0,0,0,.17c0,.05,0,0,0-.15l.09.45v-.18a2.55,2.55,0,0,0,.3.26c.14-.49.22-1.19.48-1.41a4.69,4.69,0,0,0,.11.94c-.13-.41-.21.21-.38.15.09,0,.1.22.08.29l.24-.42c0,.33.09.24.18.36-.14-.63.15-.45.23-.66,0,.21.05.43-.1.4.23.46.09-.77.3-.39,0,0-.06,0,0,.09,0-.21.26-.09.25.1l0,0a.55.55,0,0,0,.61-.67c0,.07.1.65.11.77,0-.63,0-1.26,0-1.89.07.47.45,1.53.32,1.83.07.06.15.12.23-.07a2.06,2.06,0,0,1-.2-.7,3.32,3.32,0,0,0,.42.65c-.08-.09-.19-.82-.1-.82s.18.71.17.79l0-.75a2.17,2.17,0,0,0,.24.78c-.05-.13.19,0,.23-.11l-.13-.14c.27,0,0-1.05.2-1.08,0,.15.18.91.33,1a10.34,10.34,0,0,1-.17-2.11l.1.19.07-.28a14.69,14.69,0,0,1,.14,2.25c.14.13.1.23.23.17a.26.26,0,0,1,0,.34l.36,0c-.15-.4.11-.48,0-.83-.06.19-.13.36-.2.54-.14-.42-.17-1.23.05-1.23a4.89,4.89,0,0,1,.26.88c0-.15.11-.34.17-.25l0,.25c.18.11,0-.61.29-.27.06,0,.35.47.27.22a13.18,13.18,0,0,1-.88-2.23,4.4,4.4,0,0,1,.55.57c.22.33.21.9.4,1.19a1.06,1.06,0,0,1,0-.32c.08.08.11.35.2.26-.14-.42.24-.06-.08-.37.06-.16.14,0,.26,0a2.44,2.44,0,0,1-.21-1.09,1.39,1.39,0,0,0,.16.28c.23,0,.43.09.62,0,.06.09.22.16.26.35,0-.09,0-.24,0-.27.29.28-.11.12.18.48-.1-.23,0-.39,0-.58-.21-.34-.23,0-.25.22a2.4,2.4,0,0,1-.26-1.4c.08-.19.22.28.21.2.34-.06-.21-1,.2-.74a3.26,3.26,0,0,1,.49.8c-.06.19-.29-.08-.37,0l.18.08c0,.13,0,.25-.12.19.23.23.52-.23.89-.11,0-.12,0-.27-.12-.37l0,.09c-.21-.21-.08-.41-.23-.47,0-.22-.08-.55.12-.49l.24.31c-.07-.09-.21-.14-.18,0,0-.18.48.33.26-.14l-.24-.18c0-.22-.16-.64,0-.6-.27-.29,0,.05-.33-.28.38.43-.27.15.16.59-.37-.4-.26-.11-.59-.43.07.11.16.19.05.19a.66.66,0,0,0,0,.11h0a1,1,0,0,1,.15.14c.12.29,0,.36,0,.53-.09,0-.06-.15-.16-.25l0,.24c-.16-.24-.39-.33-.35-.55l-.12,0c-.14-.1-.26-.11-.26,0-.08,0,0,.36,0,.13l-.09.26,0-.06c-.19,0-.16.61-.6.24,0,.1,0,.21-.19.18l-.12-.22c0,.11-.34-.13-.27.13-.35-.59-.44,0-.63,0l.11.3c-.1,0-.16.14-.24.31l.1.27c0,.26-.35-.09-.51,0,0-.11,0-.1.08,0-.4-.54-.29.59-.63.19,0,.12-.06.1-.11,0v0h0l-.1-.13.09.13a.31.31,0,0,0-.11.16l-.11-.3v0c-.08-.1,0,.15.09.37a1.12,1.12,0,0,0,0,.2c-.18-.47-.11.2-.3-.3,0,.26-.23.26-.14.8,0-.07,0-.1,0-.11s-.16-.09-.18.07l-.11-.38,0,.55a.93.93,0,0,1-.19-.66c-.1.51-.12.21-.2.7l0-.25c-.06,0-.1.37-.17.17-.23-.45-.7.07-1.13-.34.17.74-.21-.31-.14.27-.05-.18-.11-.27-.07-.43-.16.2-.3-.25-.37.26,0-.18,0-.27,0-.37s0,.16-.07.06,0-.15,0-.23c-.17,0-.14.59-.1,1.11-.12-.24-.16-.2-.2.14,0-.16-.12-.34,0-.4-.07,0-.42-.22-.4.19,0-.1-.09,0-.11,0s-.16-.05-.3,0l0,.06c0,.5-.12.12-.23.18v-.05c-.29-.35-.12.18-.39-.23l0,.31c0,.67-.25-.38-.4-.13l.06.18c-.09.23-.24-.9-.32-1s0-.09.05-.13c-.21-.4,0,.4-.19.49,0-.21,0-.55-.06-.59s-.33.7-.47.28a.65.65,0,0,1,0,.46c-.13.06-.29-.65-.42-.13a.57.57,0,0,1,0-.13c-.1.13-.3.21-.38.49,0-1.06-.6.47-.51-.51l-.28,0,0-.1c-.16-.08-.25.15-.34.38,0-.07,0-.16,0-.21-.23-.24-.26-.2-.54.25l0-.31c-.09.17-.28-.55-.59-.23a.42.42,0,0,1,.06-.14c-.36.31-.47-1-.82.12l-.24.24c.22.14-.15.48-.1.69-.11,0-.16-.4,0-.43v.06c.18-.58-.24-.28-.14-.68-.47-.09-.81-.54-1.21-.7l-.1.46-.14-.07c0-.12.07-.37.17-.32,0-.27-.25.16-.29.25-.14-.25.26-.49.21-.52h-.1v.06c-.13.16-.21.35-.32.29s.06-.29,0-.32,0-.05,0,0l-.16-.11-.06.38c-.15.14-.16-.09-.23.34.11-.65-.59-.49-.58-.71-.22.19-.33.14-.45,0,0,.08-.16.47-.26.37.42-.75,0-.44.14-1-.1.41-.36-.07-.5.51-.06-.11.14-.29.17-.51-.39.19-.37-.45-.68-.5-.07.09-.11.27-.26.38l.17-.57c-.08,0-.4.52-.28.13,0,.09-.1.22-.15.23-.11-.39-.41-.47-.69-.61s-.51-.36-.39-.93c-.09.22-.14.2-.2.17s-.18.21-.28.33l.11-.49c-.33.28-.22-.16-.52.11h.11c-.42.27-.63.88-1.06,1.32.47-.31-.28.87.42.42,0,.13-.16.13-.23.25.21-.16.3-.16.32,0l0,0c.32.19.28.49.52.88l.16-.27a.46.46,0,0,1,0,.26c.35-.31-.18-.17.19-.53-.27.59.49.37.17,1,.12.08.16-.31.27-.24l-.07.18.16-.18c.06.08,0,.3-.12.44,0,0-.08,0-.1,0,0,.25.32.11.32.19l-.06-.16c.42,0,.69.49,1.19.3l0-.14c.36-.11.12.24.44.27l0,0c.12-.1.22-.13.28-.08-.14.12,0,.35-.18.48.39-.14.23-.14.63-.55l-.06.23c.15-.17.2-.27.35-.27-.19.14-.06.38-.29.57.09.61.63-.32.47.45.38-.56-.11-.44,0-.54s.29-.42.35-.32-.15.85.09.93c0,0,0,0-.07,0,0,.19.25-.15.27.14.19-.35.13.07.32-.4l-.26,0c.17-.09.48-.62.58-.27a.9.9,0,0,1-.22.25c0,.17.15,0,.16.12-.18.47-.3,0-.56.33,0,.23.37-.26.13.24.32-.63.21.17.53-.29l-.1.29s.14-.16.18-.14l-.2.35c.23-.28.17.36.35.23-.27-.07.05-.38,0-.62.44-.3,0,.82.37.79-.06,0-.14-.23,0-.35a.75.75,0,0,1,.12.39c.26,0,0-.31.19-.46,0,.38.16-.12.3-.21l-.08.3c.23.26.23-.61.42-.32l-.2.4.15-.08-.11.34c.21-.22.24-.15.35,0,0-.23.15-.55.27-.53,0,.19-.11.28.07.27-.07.18-.17.41-.19.11,0,.1-.08.19-.11.28s.23.1.29.11a.11.11,0,0,1,0-.09l.34-.37a.4.4,0,0,1-.08.29c.05,0,.12-.15.2-.17-.07.25-.11.51-.25.6l.31-.22c0,.11.07.32,0,.4.11.18.42-.42.57-.2a.27.27,0,0,1,.09-.12c.16.08.28.41.53.1l.05.46c.18-.08-.08-.58.2-.72s0,.39.08.52c.12-.22.33-.66.47-.28C131.36,55.69,131.32,55.62,131.27,55.65Zm2-.08c0,.06-.12.26-.14.08C133.15,55.29,133.18,55.47,133.24,55.57Zm2.9-.86c0,.1-.07,0-.13-.06S136.09,54.63,136.14,54.71Zm6.6-4.25v0C142.62,50.41,142.67,50.44,142.74,50.46Zm.19,0a.22.22,0,0,0-.05-.11c0,.07,0,.09,0,.09S142.93,50.59,142.93,50.5Zm-16.07,1.23v.09C126.76,51.88,126.81,51.81,126.86,51.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.85,55.16a1,1,0,0,1,0-.17A.22.22,0,0,0,135.85,55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130,55.65h0s0,0,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.78,54a.49.49,0,0,1-.13-.12C141.68,53.93,141.72,54,141.78,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.32,49.64l0,.12s.07,0,.12,0S143.3,49.66,143.32,49.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.13,50.72s0,0,0-.07l-.09-.11A.12.12,0,0,0,145.13,50.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144,50.46c.15.21.15.1.18,0a0,0,0,0,1,0,0C144,50.18,144,50.32,144,50.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.16,50.47a.08.08,0,0,1,.05,0C144.14,50.3,144.17,50.41,144.16,50.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143,50.26c.06,0-.15-.3-.08-.21C142.79,49.74,143,50.5,143,50.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.5 51.14 144.29 50.89 144.41 51.13 144.5 51.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.88,51.26H144a.13.13,0,0,1,0-.11C143.93,51.19,143.83,51.18,143.88,51.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144,51.16a.07.07,0,0,0,0-.1A.19.19,0,0,0,144,51.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.42 51.31 144.35 51.27 144.27 51.3 144.42 51.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.76,51.82l-.07.14c0,.1.1.15.12.09S142.83,51.9,142.76,51.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.52,52.42a.83.83,0,0,1-.17-.19l.19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.22,52.68c0,.11,0,.37.11.28C143.29,52.85,143.37,52.71,143.22,52.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.19 53.03 141.22 53.01 140.98 52.4 141.19 53.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140,55.08c.2.1-.07-.4.12-.25,0-.16-.16-.12-.16-.26C139.87,54.75,139.8,54.68,140,55.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.92,54.57l0-.11A.26.26,0,0,0,139.92,54.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.4 48.66 122.44 48.5 122.32 48.7 122.4 48.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.94,48.89l.28-.31-.31.24S122,48.82,121.94,48.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.52,56.42v-.1c0-.11,0-.12-.09-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.08 56.05 132.1 56.06 132.08 55.68 132.08 56.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.8,56.42s.12-.06.17,0C130.85,56.44,130.85,56,130.8,56.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelbeeLogo);
export default __webpack_public_path__ + "static/media/welbee_logo.a3bc8164e059c98d264caf8e2e16ec02.svg";
export { ForwardRef as ReactComponent };